import { DialogContent, DialogContentText, Typography } from '@mui/material';
import ModalCustom from 'components/Modal/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { closeDialogAction } from 'store/actions/dialogsActions';
// import { getbaseLineOrderAction } from 'store/actions/changeBaselineActions';
import { useAppState } from 'store/Provider';
import useManagementService from 'features/Management/services/useManagementService';
import { setSnackbarAction } from 'store/actions/snackbarActions';

const BaselineCancelConfirmation = () => {
  const { state, dispatch } = useAppState();
  const { dialogs } = state;
  const isOpen = dialogs.changeBaselineCancelDialog;
  const { order } = dialogs?.data;
  const { baselineCancelDialogApi } = useManagementService();
  const [t] = useTranslation();

  const confirmFn = async () => {
    const baselineVersion =
      order?.baseline_version === 0 || order?.baseline_version === null ? 1 : Number(order?.baseline_version) + 1;
    const data = await baselineCancelDialogApi(order, 5, baselineVersion, 5);
    dispatch(closeDialogAction('changeBaselineCancelDialog'));
    if (data) {
      dispatch(
        setSnackbarAction({
          message: `${order?.id} Order baseline version successfully deleted`,
          open: true,
          severity: 'success',
        })
      );
    } else {
      dispatch(
        setSnackbarAction({ message: 'The order baseline version has not been deleted', open: true, severity: 'error' })
      );
    }
  };
  const dialogBody = (
    <DialogContent>
      <DialogContentText>
        <Typography>
          <strong>{t('Are you sure you want to cancel the new baseline of this order?')}</strong>
        </Typography>
        <Typography>
          <br />
          <strong>{t('Note')}</strong> {t('Baseline_Cancel_Note')}
        </Typography>
      </DialogContentText>
    </DialogContent>
  );
  return (
    <ModalCustom
      open={isOpen}
      modalName="changeBaselineCancelDialog"
      onClose={() => dispatch(closeDialogAction('changeBaselineCancelDialog'))}
      onConfirm={() => confirmFn()}
      titleText="Confirmation"
      confirmText=" Yes "
      cancelText="No"
      body={dialogBody}
      size="md"
      confirmLoad
    />
  );
};

export default BaselineCancelConfirmation;
